module.exports = __webpack_public_path__ + "static/media/courses-card-image.684026d1.png";